
import { UseFormRegister, UseFormWatch, UseFormSetValue } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { Textarea } from '@/components/ui/textarea';
import { Separator } from '@/components/ui/separator';
import type { Application } from '@/types/database.types';

interface CurrentCoverageProps {
  register: UseFormRegister<Partial<Application>>;
  watch: UseFormWatch<Partial<Application>>;
  setValue: UseFormSetValue<Partial<Application>>;
}

export const CurrentCoverage = ({
  register,
  watch,
  setValue
}: CurrentCoverageProps) => {
  const hasHighCostClaims = watch('has_high_cost_claims');
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Current Coverage Details</h3>
      <Separator className="my-2" />
      
      <div className="flex items-center space-x-2">
        <Checkbox
          id="has_high_cost_claims"
          checked={Boolean(hasHighCostClaims)}
          onCheckedChange={(checked) => {
            setValue('has_high_cost_claims', !!checked);
            if (!checked) {
              setValue('high_cost_claims_details', '');
            }
          }}
        />
        <Label htmlFor="has_high_cost_claims" className="cursor-pointer">
          Have any high cost claims ($25,000+) in the past 24 months
        </Label>
      </div>
      
      {hasHighCostClaims && (
        <div className="space-y-2 ml-6">
          <Label htmlFor="high_cost_claims_details">Provide details on high cost claims</Label>
          <Textarea
            id="high_cost_claims_details"
            {...register('high_cost_claims_details')}
            placeholder="Please provide details about nature of claims, estimated costs, and current status"
            rows={4}
          />
        </div>
      )}
      
      <div className="flex items-center space-x-2">
        <Checkbox
          id="medical_with_peo"
          checked={Boolean(watch('medical_with_peo'))}
          onCheckedChange={(checked) => setValue('medical_with_peo', !!checked)}
        />
        <Label htmlFor="medical_with_peo" className="cursor-pointer">
          Medical insurance through PEO
        </Label>
      </div>
      
      <div className="flex items-center space-x-2">
        <Checkbox
          id="workers_comp_with_peo"
          checked={Boolean(watch('workers_comp_with_peo'))}
          onCheckedChange={(checked) => setValue('workers_comp_with_peo', !!checked)}
        />
        <Label htmlFor="workers_comp_with_peo" className="cursor-pointer">
          Workers' comp through PEO
        </Label>
      </div>
      
      <div className="flex items-center space-x-2">
        <Checkbox
          id="ancillary_with_peo"
          checked={Boolean(watch('ancillary_with_peo'))}
          onCheckedChange={(checked) => setValue('ancillary_with_peo', !!checked)}
        />
        <Label htmlFor="ancillary_with_peo" className="cursor-pointer">
          Ancillary benefits through PEO
        </Label>
      </div>
    </div>
  );
};
